<template>
  <div ref="grecaptcha" class="recaptcha-container"></div>
</template>

<script>
import { v2 as siteKey } from '@/config/reCAPCHA'
export default {
  name: 'Recaptcha',
  data: () => ({
    widget: null
  }),
  mounted() {
    this.init()
  },

  beforeDestroy() {
    window.grecaptcha.reset(this.widget)
  },

  methods: {
    init() {
      window.ReCaptchaLoaded = this.loaded
      const script = document.createElement('script')
      script.src =
        'https://www.google.com/recaptcha/api.js?onload=ReCaptchaLoaded&render=explicit'
      document.head.appendChild(script)
    },
    loaded() {
      this.widget = window.grecaptcha.render(this.$refs.grecaptcha, {
        sitekey: siteKey,
        callback: (response) => this.$emit('change', response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.recaptcha-container {
  padding: 0;
  margin-bottom: 15px;
}
@media (min-width: 768px) {
  .recaptcha-container {
    width: 75%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
